import {
  HttpErrorResponse,
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpStatusCode,
  HttpUserEvent,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, timer } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { log } from 'src/app/core/helpers/logger';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<unknown> | HttpUserEvent<unknown>> {
    return next.handle(req).pipe(
      catchError(err => {
        if (this.shouldRetry(err)) {
          return this.retry(req, next);
        }
        return throwError(() => err as unknown);
      })
    );
  }
  shouldRetry(err: unknown): boolean {
    // retry only if the request has timed out
    // or if the error wasn't caused by the client (i.e. not 4xx errors)
    // also skip retry on internal server error
    if (err instanceof HttpErrorResponse) {
      const status = err.status as HttpStatusCode;
      return status === HttpStatusCode.RequestTimeout || (status !== HttpStatusCode.InternalServerError && !status.toString().startsWith('4'));
    }
    return false;
  }
  retry(
    req: HttpRequest<unknown>,
    next: HttpHandler,
    retries: number = 1
  ): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<unknown> | HttpUserEvent<unknown>> {
    return timer(retries * 100).pipe(
      mergeMap(() => {
        log('Retry #' + retries);
        return next.handle(req).pipe(
          catchError(err => {
            if (retries >= 2) {
              return throwError(() => err as unknown);
            }
            ++retries;
            return this.retry(req, next, retries);
          })
        );
      })
    );
  }
}
